export default function CaseResultsSection() {
  const results = [
    {
      amount: '$285,000',
      type: 'Industrial Accident',
      description: 'Secured substantial settlement for manufacturing worker with severe back injury and permanent disability.',
      height: 'h-80',
    },
    {
      amount: '$156,000',
      type: 'Repetitive Strain Injury',
      description: 'Won appeal for warehouse worker denied benefits for carpal tunnel syndrome.',
      height: 'h-64',
    },
    {
      amount: '$420,000',
      type: 'Construction Accident',
      description: 'Maximum benefits awarded for construction worker with multiple injuries from fall.',
      height: 'h-96',
    },
    {
      amount: '$198,000',
      type: 'Occupational Disease',
      description: 'Successfully proved work-related respiratory condition for factory employee.',
      height: 'h-72',
    },
    {
      amount: '$312,000',
      type: 'Psychological Injury',
      description: 'Landmark case securing benefits for PTSD following workplace trauma.',
      height: 'h-88',
    },
    {
      amount: '$175,000',
      type: 'Denied Claim Appeal',
      description: 'Overturned denial and secured full benefits for injured healthcare worker.',
      height: 'h-64',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Proven Results for Injured Workers
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Millions recovered in workers' compensation benefits for Northeast Ohio clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {results.map((result, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 ${result.height} flex flex-col justify-between`}
            >
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-3">{result.amount}</div>
                <div className="text-lg font-semibold text-gray-900 mb-3">{result.type}</div>
                <p className="text-sm text-gray-600 leading-relaxed">{result.description}</p>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <span className="text-xs text-gray-500">Past results do not guarantee future outcomes</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/case-results"
            className="inline-flex items-center px-8 py-4 bg-gray-900 text-white rounded-full text-base font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
          >
            View All Case Results
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}